import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'

const Benefits = () => {
  const { translate } = useTranslations()

  return (
    <div>
      <div className="u-px-lg-16 u-radius-4">
        <h3 className='u-fs-lg-20 u-fs-16 fw-sm-bold'>{translate('RegisterBuinsess_Usp_B2B_Headline')}</h3>
        <ul className='u-fs-lg-16 u-fs-14'>
          <li>{translate('Register_Usp_One')}</li>
          <li>{translate('Register_Usp_Two')}</li>
          <li>{translate('Register_Usp_Three')}</li>
        </ul>
      </div>
    </div>
  )
}

export default Benefits
